module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_c('section', {
    staticClass: "banner-area section index_banner_box"
  }, [_c('div', {
    staticClass: "banner_swiper swiper-container swiper-container-fade swiper-container-initialized swiper-container-horizontal"
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "transition-duration": "0ms"
    }
  }, _vm._l((_vm.bannerlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide",
      staticStyle: {
        "width": "1903px",
        "opacity": "1",
        "transition-duration": "0ms",
        "margin-right": "0px !important"
      },
      attrs: {
        "data-swiper-slide-index": index
      }
    }, [_c('div', {
      staticClass: "img_box"
    }, [_c('img', {
      staticClass: "ani",
      staticStyle: {
        "visibility": "hidden"
      },
      attrs: {
        "src": item.pic,
        "swiper-animate-effect": "toSmall",
        "swiper-animate-duration": "5s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "text_box"
    }, [_c('h3', {
      staticClass: "ani fadeInUp80 animated",
      staticStyle: {
        "visibility": "visible",
        "animation-duration": "1s",
        "-webkit-animation-duration": "1s",
        "animation-delay": "0s",
        "-webkit-animation-delay": "0s"
      },
      attrs: {
        "swiper-animate-effect": "fadeInUp80",
        "swiper-animate-duration": "1s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]), _vm._v(" "), _c('h2', {
      staticClass: "ani fadeInUp80 animated",
      staticStyle: {
        "visibility": "visible",
        "animation-duration": "1s",
        "-webkit-animation-duration": "1s",
        "animation-delay": "0s",
        "-webkit-animation-delay": "0s"
      },
      attrs: {
        "swiper-animate-effect": "fadeInUp80",
        "swiper-animate-duration": "1s",
        "swiper-animate-delay": "0s",
        "swiper-animate-style-cache": "visibility: hidden;"
      }
    }, [_vm._v("\n                " + _vm._s(item.subtitle) + "\n              ")])])])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "swiper-notification",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "banner_thumber swiper-container-initialized swiper-container-horizontal swiper-container-thumbs"
  }, [_c('div', {
    staticClass: "swiper-wrapper",
    staticStyle: {
      "transform": "translate3d(0px, 0px, 0px)",
      "transition-duration": "0ms"
    }
  }, _vm._l((_vm.bannerlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "swiper-slide"
    }, [_c('span'), _vm._v(" "), _c('p', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "xz"
    }, [_c('div', {
      staticClass: "progressb"
    }, [_c('div', {
      staticClass: "circle",
      attrs: {
        "data-name": "CSS Skill",
        "data-percent": "100%"
      }
    }, [_c('svg', {
      attrs: {
        "viewBox": "-10 -10 220 220"
      }
    }, [_c('g', {
      attrs: {
        "fill": "none",
        "stroke-width": "6",
        "transform": "translate(100,100)"
      }
    }, [_c('path', {
      attrs: {
        "d": "M 0,-100 A 100,100 0 0,1 86.6,-50 A 100,100 0 0,1 86.6,50 A 100,100 0 0,1 0,100 A 100,100 0 0,1 -86.6,50 A 100,100 0 0,1 -86.6,-50 A 100,100 0 0,1 0,-100"
      }
    })])]), _vm._v(" "), _c('svg', {
      attrs: {
        "viewBox": "-10 -10 220 220"
      }
    }, [_c('path', {
      attrs: {
        "d": "M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z",
        "stroke-dashoffset": "629"
      }
    })])])]), _vm._v(" "), _vm._m(0, true)])])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "swiper-notification",
    attrs: {
      "aria-live": "assertive",
      "aria-atomic": "true"
    }
  })])]), _vm._v(" "), _c('section', {
    staticClass: "section feature-area section-padding2",
    staticStyle: {
      "background": "url('../static/assets/images/producis.png') no-repeat"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container homecp912 sun913pc"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.lanmulist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 texiao donghuasun",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s",
        "visibility": "visible",
        "max-width": "19%"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/category?id=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-feature mb-4 mb-lg-0"
    }, [_c('h4', {
      staticStyle: {
        "height": "45px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subname))]), _vm._v(" "), _c('div', {
      staticClass: "xincpfm"
    }, [_c('img', {
      staticClass: "shrinkable-image",
      attrs: {
        "src": _vm.newurl + item.ico,
        "alt": "Your Image"
      }
    })])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "sun913sj",
    staticStyle: {
      "max-width": "100%",
      "height": "100%"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "homecp912",
    staticStyle: {
      "max-width": "100%",
      "height": "85%",
      "position": "absolute",
      "width": "100%",
      "bottom": "0px",
      "background": "url('../static/assets/images/beijzz.png') no-repeat bottom",
      "background-size": "100%"
    }
  }, _vm._l((_vm.lanmulist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 texiao donghuasun",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.3s",
        "width": "45%",
        "margin-left": "3%",
        "float": "left"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/category?id=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-feature mb-4 mb-lg-0",
      staticStyle: {
        "height": "90%",
        "padding": "0px",
        "border-radius": "6px"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "140px",
        "text-align": "center",
        "bottom": "15%",
        "right": "0px"
      }
    }, [_c('img', {
      staticClass: "shrinkable-image",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.newurl + item.ico,
        "alt": "Your Image"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "line",
      staticStyle: {
        "width": "100%"
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "height": "60%",
        "line-height": "40px",
        "font-size": "16px",
        "text-align": "center"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.truncatechanpin(item.name)) + "\n                ")])])])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "category-area section-padding section section-padding99",
    staticStyle: {
      "background": "url('../static/assets/images/solve_bg.jpg') no-repeat center"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "sun913sj",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('ul', [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[2].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist1",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg1.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[2]['title']) + "\n              ")])])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[1].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist2",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg2.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[1]['title']) + "\n              ")])])]), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[0].id,
      "target": "_blank"
    }
  }, [_c('li', {
    staticClass: "idx_falist3 active",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg3.jpg')",
      "left": "0px",
      "height": "140px",
      "background-size": "100%",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "50px",
      "line-height": "50px",
      "color": "#fff",
      "padding": "50px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.fanganlist[0]['title']) + "\n              ")])])])]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "idx_fa animate fadeInUp animated donghuasun sun913pc",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s",
      "visibility": "visible"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "idx_falist1",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg1.jpg')",
      "left": "0px"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[2].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[2]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[2]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[2]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "idx_falist2",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg2.jpg')",
      "left": "25%"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[1].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[1]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[1]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[1]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])]), _vm._v(" "), _c('li', {
    staticClass: "idx_falist3 active",
    staticStyle: {
      "background-image": "url('../static/assets/images/idxfaimg3.jpg')",
      "left": "50%"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "black"
    },
    attrs: {
      "href": '/jiejueinfo?id=' + _vm.fanganlist[0].id,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "idxfa_title flexrow"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[0]['title']))])]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc animate fadeIn animated",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeIn",
      "data-duration": "1.5s",
      "data-delay": "0.1s"
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.fanganlist[0]['title']))]), _vm._v(" "), _c('div', {
    staticClass: "idx_fadesc_item"
  }, [_c('p', [_vm._v(_vm._s(_vm.fanganlist[0]['description']))]), _vm._v(" "), _c('button', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("了解更多 >")])])])])])]), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('section', {
    staticClass: "jobs-area section-padding3 section"
  }, [_c('div', {
    staticClass: "container homecontainer",
    staticStyle: {
      "position": "absolute",
      "top": "15%",
      "margin-left": "10%"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "donghuaLeft",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.5s",
      "width": "50%",
      "float": "left",
      "padding-right": "5%"
    }
  }, [_c('p', {
    staticClass: "homeaboutsj",
    staticStyle: {
      "font-weight": "bold",
      "font-size": "18px"
    }
  }, [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")]), _vm._v(" "), _c('p', {
    staticClass: "hongaboutsja",
    staticStyle: {
      "color": "#666666",
      "line-height": "34px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.aboutinfo.description) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "donghuaRight llsunz",
    staticStyle: {
      "width": "40%",
      "float": "left",
      "animation-duration": "1s",
      "animation-delay": "1s"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.newurl + _vm.aboutinfo.ico
    }
  })])])]), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding4 section",
    staticStyle: {
      "width": "100% !important"
    }
  }, [_c('div', {
    staticClass: "sun"
  }, [_c('div', {
    staticClass: "suna"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "suna_b donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[1]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[1]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[1]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb"
  }, [_c('div', {
    staticClass: "sunb_a donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[3]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[3]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[3]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[0]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[0]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[0]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunc"
  }, [_c('div', {
    staticClass: "idx_pros donghuasunfadeIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.6s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/yingyong"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.hangyelist[2]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "kongnidiv",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.hangyelist[2]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.hangyelist[2]['description']))])])])])])])])])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('section', {
    staticClass: "section-padding5 section",
    staticStyle: {
      "width": "100% !important"
    }
  }, [_c('div', {
    staticClass: "sun"
  }, [_c('div', {
    staticClass: "suna"
  }, [_c('div', {
    staticClass: "idx_pros donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.1s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[0]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticClass: "jsfw_1108",
    staticStyle: {
      "color": "#ffffff",
      "text-align": "center",
      "line-height": "46px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "500"
    }
  }, [_vm._v("TECHNICAL SERVICE")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("技术服务")]), _vm._v(" "), _c('p', {
    staticClass: "jsfw_new_zt",
    staticStyle: {
      "font-size": "16px",
      "margin-top": "100px"
    }
  }, [_vm._v(_vm._s(_vm.fuwulist[0]['description']) + "\n                      ")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb"
  }, [_c('div', {
    staticClass: "sunb_a"
  }, [_c('div', {
    staticClass: "sunb_a_a donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[4]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[4]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[4]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_a_b donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[3]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[3]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[3]['description']))])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b"
  }, [_c('div', {
    staticClass: "sunb_b_a donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "1.1s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[2]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[2]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[2]['description']))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sunb_b_b donghuaIn",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "1.4s"
    }
  }, [_c('div', {
    staticClass: "idx_pros"
  }, [_c('ul', [_c('li', {
    staticClass: "animate fadeInUp animated",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    },
    attrs: {
      "data-animate": "fadeInUp",
      "data-duration": "2s",
      "data-delay": "1s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/fuwu"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.newurl + _vm.fuwulist[1]['ico']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "idx_pros_desc flexrow"
  }, [_c('div', {
    staticStyle: {
      "color": "#ffffff",
      "text-align": "left",
      "line-height": "36px",
      "padding": "10%"
    }
  }, [_c('p', {
    staticClass: "hangyeyingyong"
  }, [_c('strong', [_vm._v(_vm._s(_vm.fuwulist[1]['title']))])]), _vm._v(" "), _c('p', {
    staticClass: "buxianshi"
  }, [_vm._v(_vm._s(_vm.fuwulist[1]['description']))])])])])])])])])])])])]), _vm._v(" "), _c('section', {
    staticClass: "section-padding7 section"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "row donghuaLeft",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.6s"
    }
  }, _vm._l((_vm.newslist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-lg-4 col-md-6",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('a', {
      staticStyle: {
        "color": "black"
      },
      attrs: {
        "href": '/blogDetails?id=' + item.id + '&cid=' + item.scode,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "single-news mb-5 mb-lg-0 qudiaodibu"
    }, [_c('div', {
      staticClass: "news-img news-img1",
      style: ('background-image: url(' + _vm.newurl + item.ico + '); left: 50%;')
    }), _vm._v(" "), _c('div', {
      staticClass: "news-tag qudiaomarg",
      staticStyle: {
        "padding": "0px 20px"
      }
    }, [_c('ul', {
      staticClass: "my-4 qudiaomarg",
      staticStyle: {
        "font-size": "20px"
      }
    }, [_c('li', [_c('h5', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('i', {
      staticClass: "fa fa-calendar-o"
    }), _vm._v(_vm._s(_vm.truncateDate(item.date)))])]), _vm._v(" "), _vm._m(11, true), _vm._v(" "), _c('li', [_c('h5', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.sortname))])])])]), _vm._v(" "), _c('div', {
      staticClass: "news-title",
      staticStyle: {
        "padding": "0px 20px"
      }
    }, [_c('h4', {
      staticClass: "bianhuaduoduan",
      staticStyle: {
        "line-height": "28px"
      }
    }, [_c('a', {
      staticClass: "xinwen",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(_vm.truncatetitle(item.title)) + "..")])]), _vm._v(" "), _c('p', {
      staticClass: "buxianshi",
      staticStyle: {
        "font-size": "16px",
        "color": "#666666"
      }
    }, [_vm._v(_vm._s(_vm.truncatecontent(item.description)) + " ...\n                  ")]), _vm._v(" "), _c('p', {
      staticClass: "buxianshi",
      staticStyle: {
        "font-size": "16px",
        "color": "#666666",
        "margin-top": "50px"
      }
    }, [_vm._v("了解更多 >>")])])])])])
  }), 0), _vm._v(" "), _vm._m(12)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "2%"
    }
  }, [_vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(15)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jt"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/jz.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wow fadeInUp sun913pc",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('p', {
    staticClass: "phonecpzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "margin-top": "150px"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("产品中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "15%",
      "text-align": "center",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('p', {
    staticClass: "phonecpzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "margin-top": "150px"
    }
  }, [_vm._v("PRODUCTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("产品中心")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container donghuasun"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("SOLUTIONS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#ffffff"
    }
  }, [_vm._v("解决方案")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idx_sun"
  }, [_c('span', {
    staticClass: "sun_xza",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzb",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzc",
    staticStyle: {
      "padding-left": "60px"
    }
  }, [_vm._v("●")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "idx_sun"
  }, [_c('span', {
    staticClass: "sun_xza",
    staticStyle: {
      "padding-right": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzb",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("●")]), _vm._v(" "), _c('span', {
    staticClass: "sun_xzc",
    staticStyle: {
      "padding-left": "60px"
    }
  }, [_vm._v("●")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuasun about_sun",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9",
      "font-weight": "bold"
    }
  }, [_vm._v("ABOUT US")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("公司简介")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-job-btn mt-5 text-center donghuasunfadeIn liaojiesunbbc",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1.5s"
    }
  }, [_c('a', {
    staticClass: "template-btn",
    attrs: {
      "href": "/about",
      "target": "_blank"
    }
  }, [_vm._v("了解更多")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "suna_a donghuaDown",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "ipahyyy",
    staticStyle: {
      "width": "40%",
      "height": "50%",
      "text-align": "right",
      "margin-left": "15%"
    }
  }, [_c('p', {
    staticClass: "hyyy_new_ywzt",
    staticStyle: {
      "font-size": "24px",
      "color": "#ffffff",
      "font-weight": "500",
      "margin-left": "-4px"
    }
  }, [_vm._v("\n                  INDUSTRIES")]), _vm._v(" "), _c('p', {
    staticClass: "hyyy_new_zt",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("行业应用")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-padding6 section"
  }, [_c('div', {
    staticClass: "container donghuasun",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#44BCB9"
    }
  }, [_vm._v("ADVANTAGES")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#666666"
    }
  }, [_vm._v("拿度优势")])])]), _vm._v(" "), _c('div', {
    staticClass: "homeyoushi",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "advantage_num donghuaIn",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "1s"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "donghuasun",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.4s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage01.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("6")]), _c('i', [_vm._v("大")])]), _vm._v(" "), _c('p', [_vm._v("主要业务板块，"), _c('br'), _vm._v("\n                  磁致伸缩位移传感器、激光传感器")])])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.7s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage02.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("10")]), _c('i', [_vm._v("年")])]), _vm._v(" "), _c('p', [_vm._v("十年以上的行业经验，"), _c('br'), _vm._v("\n                  强大的传感器研发、设计和测试工程师团队")])])]), _vm._v(" "), _c('li', {
    staticClass: "donghuasun",
    staticStyle: {
      "animation-duration": "1.5s",
      "animation-delay": "0.9s"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage03.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', [_vm._v("60")]), _c('i', [_vm._v("种")])]), _vm._v(" "), _c('p', [_vm._v("位移传感器产品，"), _c('br'), _vm._v("\n                  技术上追求“度”，做事上立本于“度”")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row donghuasun",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top xinwen_biaoti",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('h2', {
    staticStyle: {
      "color": "#44BCB9",
      "font-weight": "500",
      "font-size": "24px"
    }
  }, [_vm._v("NEWS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "normal",
      "font-size": "24px"
    }
  }, [_vm._v("新闻资讯")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "separator mx-2"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuaRight",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "text-align": "center",
      "line-height": "100px",
      "animation-duration": "1s",
      "animation-delay": "0.6s"
    }
  }, [_c('a', {
    attrs: {
      "href": "/blog?id=15",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "download-btn"
  }, [_vm._v("\n              查看全部新闻 +\n            ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cd49edf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 106
// module chunks = 0